module.exports = __webpack_public_path__ + "img/spain-infectious-diseases-male.fc8d0b21.png";